import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const sliceName = "countryChart";

export const fetchCountriesChart = createAsyncThunk(
  `${sliceName}/fetchCountriesChart`,
  async (selectedCountry) => {
    const data = await axios.get(
      `https://disease.sh/v2/historical/${selectedCountry}?lastdays=all`
    );
    return data;
  }
);

export const countriesChartSlice = createSlice({
  name: sliceName,
  initialState: {
    chart: [],
    cases: [],
    recovered: [],
    deaths: [],
    dates: [],
    isLoading: false,
    country: "",
    error: "",
  },
  reducers: {},
  extraReducers: {
    [fetchCountriesChart.pending]: (state) => {
      state.error = null;
      state.isLoading = true;
      state.chart = [];
    },
    [fetchCountriesChart.fulfilled]: (state, action) => {
      state.error = null;
      state.isLoading = false;
      state.country = action.payload.data.country;
      state.cases = Object.values(action.payload.data.timeline.cases);
      state.recovered = Object.values(action.payload.data.timeline.recovered);
      state.deaths = Object.values(action.payload.data.timeline.deaths);
      state.dates = Object.keys(action.payload.data.timeline.cases);
    },
    [fetchCountriesChart.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = "Sorry no data available, please try later";
    },
  },
});
export const { actions, reducer } = countriesChartSlice;
export default reducer;
export const selectCountriesChart = (state) => state.chart;
